<!-- Breadcrumb -->
<div
    class="breadcrumb-card mb-25 d-md-flex align-items-center justify-content-between"
>
    <h5 class="mb-0">Tenant</h5>
    <ol class="breadcrumb list-unstyled mt-0 mb-0 p-0">
        <li class="breadcrumb-item d-inline-block position-relative">
            <a routerLink="/dashboard" class="d-inline-block position-relative">
                <i class="material-symbols-outlined"> home </i>
                Dashboard
            </a>
        </li>
        <li class="breadcrumb-item d-inline-block position-relative">Tenant</li>
        <li class="breadcrumb-item d-inline-block position-relative">
           Tenant List
        </li>
    </ol>
</div>

<div
    class="crm-leads-card trezo-card mb-25 border-radius d-block bg-white border-0 shadow-none"
>
    <div
        class="trezo-card-header d-sm-flex align-items-center justify-content-between"
    >
        <div class="trezo-card-title">
            <h5 class="mb-0">Tenant List</h5>
        </div>
        <div class="trezo-card-subtitle">
            <button
                class="add-btn d-inline-block transition fw-medium border-radius"
                type="button"
                (click)="onAddClick()"
            >
                <span class="d-inline-block position-relative">
                    <i class="material-symbols-outlined"> add </i>
                    Add New Tenant
                </span>
            </button>
        </div>
    </div>
    <div class="trezo-card-content">
        <app-table
            [datasource$]="createb2bclients$"
            [columns]="columns"
            [pageIndex]="pageIndex"
            [pageSize]="pageSize"
            [pageSizeOptions]="pageSizeOptions"
            [actionButtons]="actions"
            [sortable]="true"
            [usePagination]="true"
            [useFilter]="false"
            [queryParameters]="searchOptions"
            [resultLength]="totalRecords"
            [useStickyHeaders]="false"
            [allowRowSelection]="true"
            [allowDragDrop]="false"
            (eventHandler)="tableEvent($event)"
        >
        </app-table>
    </div>
</div>

<!-- Add New Popup -->
<div class="add-new-popup" [class.active]="classApplied">
    <app-b2bclient-details
        *ngIf="classApplied"
        [data]="createb2bclient"
        (saveConfirmationEvent)="saveConfirmationEvent($event)"
        (classApplied)="classAppliedEvent($event)"
    />
</div>

<!-- Image Modal -->
<div
    class="modal fade"
    [class.show]="showImageModal"
    [style.display]="showImageModal ? 'block' : 'none'"
    tabindex="-1"
    role="dialog"
    *ngIf="showImageModal"
>
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">{{ selectedImageTitle }}</h4>
                <button type="button" class="btn-close" (click)="closeImageModal()" aria-label="Close"></button>
            </div>
            <div class="modal-body text-center">
                <img
                    [src]="selectedImageUrl"
                    [alt]="selectedImageTitle"
                    class="img-fluid"
                    style="max-height: 500px; border-radius: 8px"
                />
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="closeImageModal()">Close</button>
            </div>
        </div>
    </div>
</div>
<div class="modal-backdrop fade" [class.show]="showImageModal" *ngIf="showImageModal" (click)="closeImageModal()"></div>
